export default {
  methods: {
    /**
     * Возвращает суммарный размер файлов.
     *
     * @param {Array} files
     * @returns {number}
     */
    filesSize (files) {
      let size = 0
      for (const file of files) {
        size = size + file.size
      }

      return size
    },
    /**
     * Не превышает ли суммарный размер файлов максимальный суммарный размер.
     *
     * @param files
     * @param maxFilesSize
     * @returns {boolean}
     */
    isFilesSizeCorrect (files, maxFilesSize) {
      return this.filesSize(files) <= maxFilesSize
    }
  }
}
